<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <!-- <SnackBar
      v-bind:msg="msg"
      v-bind:showSnackBar="showSnackBar"
      @stepper="showSnackBar = false"
    /> -->
    <v-app>
      <v-snackbar
        v-model="showSnackBar"
        color="#3EA56E"
        right
        :timeout="timeout"
      >
        <v-layout wrap justify-center>
          <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
          <v-flex text-right>
            <v-btn small :ripple="false" text @click="showSnackBar = false">
              <v-icon style="color: white">mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-snackbar>
      <v-dialog
        v-model="cropImageDialog"
        persistent
        :width="
          $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
            ? '100vw'
            : $vuetify.breakpoint.name == 'md'
            ? '80vw'
            : $vuetify.breakpoint.name == 'lg'
            ? '50vw'
            : '40vw'
        "
      >
        <v-card>
          <v-layout wrap justify-center pa-2>
            <v-flex xs12>
              <ImageCropper
                :image="currentImage"
                :width="1"
                :height="1"
                :key="currentImage"
                :imageType="'profilePic'"
                @stepper="imageCropper"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="cropCoverImageDialog"
        persistent
        :width="
          $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
            ? '100vw'
            : $vuetify.breakpoint.name == 'md'
            ? '80vw'
            : $vuetify.breakpoint.name == 'lg'
            ? '50vw'
            : '40vw'
        "
      >
        <v-card>
          <v-layout wrap justify-center pa-2>
            <v-flex xs12>
              <ImageCropper
                :image="currentImage2"
                :key="currentImage2"
                :imageType="'coverPic'"
                @stepper="imageCropper"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      <v-layout wrap justify-center>
        <v-flex px-2 xs12 sm12 md10 lg9 xl8 text-left>
          <v-layout pt-8 wrap justify-center>
            <v-flex text-center xs12 md12 lg12>
              <span
                style="
                  color: #000000;
                  font-family: poppinsbold;
                  font-size: 22px;
                "
                >Register and Start Selling</span
              >
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex text-center xs12 md12 lg12>
              <span
                style="
                  color: #000000;
                  font-family: poppinsregular;
                  letter-spacing: 0.45px;
                  font-size: 14px;
                  text-align: left;
                "
                >Please ensure that all the information you submit is
                accurate.</span
              >
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 pt-8>
              <span
                class="pl-3"
                style="
                  color: #000000;
                  font-family: opensansbold;
                  font-size: 15px;
                  letter-spacing: 0px;
                  text-align: left;
                "
                >Name of the Company / Shop</span
              >
              <v-text-field
                color="#3EA56E"
                placeholder="Name of the Company / Shop"
                outlined
                dense
                type="text"
                :rules="[rules.required]"
                v-model="seller.organization"
              ></v-text-field>
              <span
                class="pl-3"
                style="
                  color: #000000;
                  font-family: opensansbold;
                  font-size: 15px;
                  letter-spacing: 0px;
                  text-align: left;
                "
                >About Us</span
              >
              <v-textarea
                color="#3EA56E"
                placeholder="About Us"
                outlined
                dense
                rows="3"
                v-model="seller.about"
              ></v-textarea>
              <span
                class="pl-3"
                style="
                  color: #000000;
                  font-family: opensansbold;
                  font-size: 15px;
                  letter-spacing: 0px;
                  text-align: left;
                "
                >Name of the owner</span
              >
              <v-text-field
                ref="ownername"
                color="#3EA56E"
                placeholder="Name of the Owner"
                outlined
                dense
                :rules="[rules.required]"
                v-model="seller.ownername"
              ></v-text-field>

              <span
                class="pl-3"
                style="
                  color: #000000;
                  font-family: opensansbold;
                  font-size: 15px;
                  letter-spacing: 0px;
                  text-align: left;
                "
                >Address Line</span
              >
              <v-card class="mx-auto mb-6" outlined>
                <v-layout wrap pa-3>
                  <v-flex xs12 md12 lg12>
                    <span
                      class="pl-3"
                      style="
                        color: #000000;
                        font-family: opensansbold;
                        font-size: 14px;
                        letter-spacing: 0px;
                        text-align: left;
                      "
                      >Address of the Owner</span
                    >
                    <v-text-field
                      ref="streetAddress"
                      color="#3EA56E"
                      placeholder="Address of the Owner"
                      outlined
                      dense
                      v-model="seller.streetAddress"
                    ></v-text-field>
                    <v-layout wrap>
                      <v-flex xs5 md5 lg5>
                        <span
                          style="
                            color: #000000;
                            font-family: opensansbold;
                            font-size: 14px;
                            letter-spacing: 0px;
                            text-align: left;
                          "
                          >Locality</span
                        >
                        <v-text-field
                          ref="locality"
                          color="#3EA56E"
                          placeholder="Locality"
                          dense
                          v-model="seller.locality"
                        ></v-text-field>
                      </v-flex>

                      <v-flex offset-md1 xs5 md5 lg5>
                        <span
                          style="
                            color: #000000;
                            font-family: opensansbold;
                            font-size: 14px;
                            letter-spacing: 0px;
                            text-align: left;
                          "
                          >City</span
                        >
                        <v-text-field
                          ref="city"
                          color="#3EA56E"
                          placeholder="City"
                          dense
                          v-model="seller.city"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5 md5 lg5>
                        <span
                          style="
                            color: #000000;
                            font-family: opensansbold;
                            font-size: 14px;
                            letter-spacing: 0px;
                            text-align: left;
                          "
                          >District</span
                        >
                        <v-text-field
                          ref="district"
                          color="#3EA56E"
                          placeholder="District"
                          dense
                          v-model="seller.district"
                        ></v-text-field>
                      </v-flex>

                      <v-flex offset-md1 xs5 md5 lg5>
                        <span
                          style="
                            color: #000000;
                            font-family: opensansbold;
                            font-size: 14px;
                            letter-spacing: 0px;
                            text-align: left;
                          "
                          >State</span
                        >
                        <v-text-field
                          ref="state"
                          color="#3EA56E"
                          placeholder="State"
                          dense
                          v-model="seller.state"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5 md5 lg5>
                        <span
                          style="
                            color: #000000;
                            font-family: opensansbold;
                            font-size: 14px;
                            letter-spacing: 0px;
                            text-align: left;
                          "
                          >Pincode</span
                        >
                        <v-text-field
                          type="number"
                          ref="pincode"
                          color="#3EA56E"
                          placeholder="Pincode"
                          dense
                          required
                          :rules="pinRules"
                          v-model="seller.pincode"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>

              <span
                class="pl-3"
                style="
                  color: #000000;
                  font-family: opensansbold;
                  font-size: 15px;
                  letter-spacing: 0px;
                  text-align: left;
                "
              >
                Choose your Location
              </span>
              <v-layout pb-3 wrap>
                <v-flex lg12>
                  <v-layout wrap justify-space-around>
                    <v-flex xs5 md5 lg5>
                      <span
                        style="
                          color: #000000;
                          font-family: opensansbold;
                          font-size: 14px;
                          letter-spacing: 0px;
                          text-align: left;
                        "
                      >
                        Latitude
                      </span>
                      <v-text-field
                        type="number"
                        ref="Latitude"
                        color="#3EA56E"
                        placeholder="Latitude"
                        dense
                        required
                        v-model.number="seller.lat"
                      ></v-text-field>
                      <!-- :rules="[rules.required]" -->
                    </v-flex>
                    <v-flex xs5 md5 lg5>
                      <span
                        style="
                          color: #000000;
                          font-family: opensansbold;
                          font-size: 14px;
                          letter-spacing: 0px;
                          text-align: left;
                        "
                      >
                        Longitude
                      </span>
                      <v-text-field
                        type="number"
                        ref="Longitude"
                        color="#3EA56E"
                        placeholder="Longitude"
                        dense
                        required
                        v-model.number="seller.lon"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg12>
                  <v-card class="mx-auto" outlined>
                    <v-layout wrap pa-3>
                      <v-flex xs12 md12 lg12 :key="seller.lon">
                        <Gmap-map
                          :key="seller.lat"
                          ref="map"
                          :center="{ lat: seller.lat, lng: seller.lon }"
                          :zoom="12"
                          style="width: 100%; height: 400px"
                          @click="clickPlace"
                          :options="{
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: true,
                            disableDefaultUi: false,
                          }"
                        >
                          <gmap-marker
                            :key="index"
                            v-for="(m, index) in markers"
                            :position="m.position"
                            @click="center = m.position"
                          ></gmap-marker>
                        </Gmap-map>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-card class="mx-auto" outlined>
                <v-layout wrap pa-3>
                  <v-flex xs12 md12 lg12>
                    <v-layout wrap>
                      <v-flex xs12 md5 lg6>
                        <span
                          style="
                            color: #000000;
                            font-family: opensansbold;
                            font-size: 15px;
                            letter-spacing: 0px;
                            text-align: left;
                          "
                          >Upload ID Proof <v-icon>mdi-upload</v-icon></span
                        >
                      </v-flex>
                      <v-flex xs1 md1 lg1>
                        <!-- <v-img src="./../../assets/images/fileupload.png" contain height="20px"></v-img> -->
                      </v-flex>
                    </v-layout>
                    <v-layout pb-1 wrap pt-2>
                      <v-flex xs12 md9 lg9>
                        <span
                          v-if="filename"
                          style="color: #000000; font-family: poppinsregular"
                          >{{ filename }}</span
                        >
                        <span
                          v-if="idproofpic"
                          style="color: #000000; font-family: poppinsregular"
                          >{{ filename }}</span
                        >
                      </v-flex>
                      <v-flex xs10 md2 lg2>
                        <span v-if="filename">
                          <v-dialog>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                style="
                                  border-radius: 14px;
                                  border: 0.5px solid #707070;
                                "
                                px-5
                                pt-0
                                text
                                small
                                outlined
                                >View</v-btn
                              >
                            </template>
                            <v-card class="mx-auto my-auto">
                              <v-toolbar elevate-on-scroll fixed>
                                Id proof
                              </v-toolbar>
                              <v-divider></v-divider>
                              <span>
                                <iframe
                                  v-if="documentImg"
                                  id="documentImg"
                                  :src="documentImg"
                                  height="700px"
                                  width="900px"
                                  contain
                                >
                                </iframe>
                              </span>
                            </v-card>
                          </v-dialog>
                        </span>
                        <span v-else>
                          <v-dialog v-if="idproofpic">
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                style="
                                  border-radius: 14px;
                                  border: 0.5px solid #707070;
                                "
                                px-5
                                pt-0
                                text
                                small
                                outlined
                                >View</v-btn
                              >
                            </template>
                            <v-card class="mx-auto my-auto">
                              <v-toolbar elevate-on-scroll fixed>
                                Id proof
                              </v-toolbar>
                              <v-divider></v-divider>
                              <span>
                                <iframe
                                  v-if="idproofpic"
                                  id="idproofpic"
                                  :src="mediaURL + idproofpic"
                                  height="700px"
                                  width="900px"
                                  contain
                                >
                                </iframe>
                              </span>
                            </v-card>
                          </v-dialog>
                        </span>
                      </v-flex>
                      <v-flex xs2 md1 lg1>
                        <span v-if="filename">
                          <v-icon @click="delDocument"
                            >mdi-delete-outline</v-icon
                          >

                          <!-- <v-img
                          @click="delDocument"
                          width="100%"
                          height="20px"
                          contain
                          src="./../../assets/images/trash.png"
                        ></v-img> -->
                        </span>
                      </v-flex>
                    </v-layout>
                    <div class="dottedline"></div>
                    <!-- <v-divider dotted></v-divider> -->
                    <v-layout wrap pt-4>
                      <v-flex xs11 md2 lg11>
                        <span
                          style="color: #000000; font-family: poppinsregular"
                          >Add</span
                        >
                      </v-flex>
                      <v-flex xs2 md10 lg1>
                        <span>
                          <v-icon
                            id="Documents"
                            @click="$refs.uploadDocuments.click()"
                            >mdi-plus</v-icon
                          >
                          <!-- <v-img
                            src="./../../assets/images/addicon.png"
                            aspect-ratio="1"
                            contain
                            height="20px"
                          >
                            <template v-slot:placeholde>                            <ImageLoader />

                            </template>
                          </v-img> -->

                          <input
                            v-show="false"
                            ref="uploadDocuments"
                            accept="image/*"
                            type="file"
                            @change="uploadDocuments"
                          />
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
              <br />
              <v-card class="mx-auto" outlined>
                <v-layout wrap pa-3>
                  <v-flex xs12 md12 lg12>
                    <v-layout pb-3 wrap>
                      <v-flex xs12 md5 lg6>
                        <span
                          style="
                            color: #000000;
                            font-family: opensansbold;
                            font-size: 15px;
                            letter-spacing: 0px;
                            text-align: left;
                          "
                          >Upload Photo <v-icon>mdi-upload</v-icon></span
                        >
                      </v-flex>
                      <v-flex lg1> </v-flex>
                      <v-flex xs10 md3 lg4>
                        <span v-if="proPicImg">
                          <v-img
                            v-if="proPicImg"
                            id="proPicImg"
                            :src="proPicImg"
                            aspect-ratio="1"
                            contain
                            height="100%"
                          >
                          </v-img>
                        </span>
                        <span v-else>
                          <v-img
                            v-if="profilepic"
                            id="profilepic"
                            :src="baseURL + 'u/' + profilepic"
                            aspect-ratio="1"
                            contain
                            height="100%"
                          >
                          </v-img>
                        </span>
                      </v-flex>
                      <v-flex text-right xs2 md1 lg1>
                        <v-icon v-if="proPicImg" @click="delProPic"
                          >mdi-delete-outline</v-icon
                        >

                        <!-- <v-img
                        @click="delProPic"
                        width="100%"
                        height="20px"
                        contain
                        src="./../../assets/images/trash.png"
                      ></v-img> -->
                      </v-flex>
                    </v-layout>

                    <div class="dottedline"></div>

                    <!-- <v-divider dotted>
                      <v-file-input
                        chips
                        multiple
                        label="File input w/ chips"
                      ></v-file-input>
                    </v-divider> -->
                    <v-layout wrap pt-4>
                      <v-flex xs10 md2 lg11>
                        <span
                          style="color: #000000; font-family: poppinsregular"
                          >Add</span
                        >
                      </v-flex>
                      <v-flex xs1 md10 lg1>
                        <span>
                          <v-icon
                            id="pro_pic"
                            @click="$refs.uploadProPicImg.click()"
                            >mdi-plus</v-icon
                          >
                          <!-- <v-img
                            src="./../../assets/images/addicon.png"
                            aspect-ratio="1"
                            contain
                            height="20px"
                          >
                            <template v-slot:placeholder>                            <ImageLoader />

                            </template>
                          </v-img> -->

                          <input
                            v-show="false"
                            ref="uploadProPicImg"
                            accept="image/*"
                            type="file"
                            @change="uploadProPicImg"
                          />
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
              <br />

              <v-card class="mx-auto" outlined>
                <v-layout wrap pa-3>
                  <v-flex xs12 md12 lg12>
                    <v-layout pb-3 wrap>
                      <v-flex xs12 md5 lg7>
                        <span
                          style="
                            color: #000000;
                            font-family: opensansbold;
                            font-size: 15px;
                            letter-spacing: 0px;
                            text-align: left;
                          "
                          >Upload Cover Photo <v-icon>mdi-upload</v-icon></span
                        >
                      </v-flex>

                      <v-flex xs10 md3 lg4>
                        <span v-if="coverPicImg">
                          <v-img
                            v-if="coverPicImg"
                            id="coverPicImg"
                            :src="coverPicImg"
                            aspect-ratio="1"
                            contain
                            height="100%"
                          >
                          </v-img>
                        </span>
                        <span v-else>
                          <v-img
                            v-if="coverpicture"
                            id="coverpicture"
                            :src="baseURL + 'u/' + coverpicture"
                            aspect-ratio="1"
                            contain
                            height="100%"
                          >
                          </v-img>
                        </span>
                      </v-flex>
                      <v-flex xs2 md1 lg1>
                        <v-icon @click="delCoverPic" v-if="coverPicImg"
                          >mdi-delete-outline</v-icon
                        >
                      </v-flex>
                    </v-layout>

                    <div class="dottedline"></div>
                    <!-- 
                    <v-divider dotted>
                      <v-file-input
                        chips
                        multiple
                        label="File input w/ chips"
                      ></v-file-input>
                    </v-divider> -->
                    <v-layout wrap pt-4>
                      <v-flex xs10 md2 lg11>
                        <span
                          style="color: #000000; font-family: poppinsregular"
                          >Add</span
                        >
                      </v-flex>
                      <v-flex xs2 md10 lg1>
                        <span>
                          <v-icon @click="$refs.uploadCoverPicImg.click()"
                            >mdi-plus</v-icon
                          >
                          <!-- <v-img
                            src="./../../assets/images/addicon.png"
                            aspect-ratio="1"
                            contain
                            height="20px"
                          >
                            <template v-slot:placeholder>                            <ImageLoader />

                            </template>
                          </v-img> -->

                          <input
                            v-show="false"
                            ref="uploadCoverPicImg"
                            accept="image/*"
                            type="file"
                            @change="uploadCoverPicImg"
                          />
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
              <br />

              <br />
              <span
                class="pl-3"
                style="
                  color: #000000;
                  font-family: opensansbold;
                  font-size: 15px;
                  letter-spacing: 0px;
                  text-align: left;
                "
                >Bank Details</span
              >
              <v-card class="mx-auto" outlined>
                <v-layout wrap pa-3>
                  <v-flex xs12 md12 lg12>
                    <span
                      style="
                        color: #000000;
                        font-family: opensansbold;
                        font-size: 14px;
                        letter-spacing: 0px;
                        text-align: left;
                      "
                      >Bank</span
                    >
                    <v-text-field
                      ref="bank"
                      color="#3EA56E"
                      placeholder="Bank"
                      dense
                      type="text"
                      :rules="[rules.required]"
                      v-model="seller.bankname"
                    ></v-text-field>
                    <span
                      style="
                        color: #000000;
                        font-family: opensansbold;
                        font-size: 14px;
                        letter-spacing: 0px;
                        text-align: left;
                      "
                      >Account Holder</span
                    >
                    <v-text-field
                      ref="accountholder"
                      color="#3EA56E"
                      placeholder="Account Holder"
                      dense
                      :rules="[rules.required]"
                      v-model="seller.accountholder"
                    ></v-text-field>

                    <span
                      style="
                        color: #000000;
                        font-family: opensansbold;
                        font-size: 14px;
                        letter-spacing: 0px;
                        text-align: left;
                      "
                      >Account Number</span
                    >
                    <v-text-field
                      ref="accountnumber"
                      color="#3EA56E"
                      placeholder="Account Number"
                      dense
                      :rules="accRules"
                      v-model="seller.accountnumber"
                    ></v-text-field>
                    <v-layout wrap>
                      <v-flex xs5 md5 lg5>
                        <span
                          style="
                            color: #000000;
                            font-family: opensansbold;
                            font-size: 14px;
                            letter-spacing: 0px;
                            text-align: left;
                          "
                          >IFSC Code</span
                        >
                        <v-text-field
                          ref="ifsc"
                          color="#3EA56E"
                          placeholder="IFSC Code"
                          dense
                          :rules="ifscRules"
                          v-model="seller.ifsccode"
                        ></v-text-field>
                      </v-flex>

                      <v-flex offset-md1 xs5 md5 lg5>
                        <span
                          style="
                            color: #000000;
                            font-family: opensansbold;
                            font-size: 14px;
                            letter-spacing: 0px;
                            text-align: left;
                          "
                          >Branch</span
                        >
                        <v-text-field
                          ref="branch"
                          color="#3EA56E"
                          placeholder="Branch"
                          dense
                          required
                          v-model="seller.branch"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
              <br />
              <span
                class="pl-3"
                style="
                  color: #000000;
                  font-family: opensansbold;
                  font-size: 15px;
                  letter-spacing: 0px;
                  text-align: left;
                "
                >GST Id</span
              >
              <v-text-field
                ref="gstid"
                color="#3EA56E"
                placeholder="GST Id"
                outlined
                :rules="gstRules"
                dense
                v-model="seller.gstid"
              ></v-text-field>
              <span
                class="pl-3"
                style="
                  color: #000000;
                  font-family: opensansbold;
                  font-size: 15px;
                  letter-spacing: 0px;
                  text-align: left;
                "
                >Email</span
              >
              <v-text-field
                ref="email"
                color="#3EA56E"
                placeholder="Email Id"
                outlined
                dense
                :rules="[rules.email]"
                v-model="seller.email"
              ></v-text-field>
              <span
                class="pl-3"
                style="
                  color: #000000;
                  font-family: opensansbold;
                  font-size: 15px;
                  letter-spacing: 0px;
                  text-align: left;
                "
                >Whatsapp number</span
              >
              <v-text-field
                ref="phone"
                color="#3EA56E"
                placeholder="Whatsapp number"
                outlined
                dense
                type="number"
                v-model="seller.whatsapp"
                :rules="phoneRules"
              >
                <template v-slot:prepend-inner>
                  <v-layout wrap justify-center>
                    <v-flex pt-1 xs18 class="align-self-center">
                      <span
                        style="
                          font-family: poppinsregular;
                          font-size: 14px;
                          color: #000;
                        "
                        >+91</span
                      >
                    </v-flex>
                    <v-flex pl-2 xs1>
                      <v-divider vertical></v-divider>
                    </v-flex>
                  </v-layout>
                  <v-card class="mx-auto" outlined></v-card>
                </template>
              </v-text-field>
              <!-- <v-text-field
              color="#63028F"
              label="Whatsapp Number"
              outlined
              dense
              v-model="seller.whatsapp"
            ></v-text-field>-->
              <v-layout wrap justify-end>
                <v-flex xs12 md12 pt-4 pb-4 text-right>
                  <v-btn
                    tile
                    block
                    dark
                    color="#3EA56E"
                    depressed
                    class="text-capitalize mb-3"
                    @click.prevent="validateInput()"
                    :ripple="false"
                    >Submit</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app>
  </div>
</template>
<script>
import axios from "axios";
import ImageCropper from "./../Common/imageCropper";
export default {
  components: {
    ImageCropper,
  },

  data() {
    return {
      markers: [],
      places: [],
      currentPlace: null,
      currentLocation: null,
      cordinates: null,
      lat: 10.535387441362912,
      lon: 76.21544288981148,
      profilepic: null,
      coverpicture: null,
      idproofpic: null,

      seller: {
        ownername: null,
        email: null,
        phone: null,
        streetAddress: null,
        organization: null,
        about: null,
        whatsapp: null,
        city: null,
        state: null,
        gstid: null,
        accountholder: null,
        accountnumber: null,
        bankname: null,
        ifsccode: null,
        branch: null,
        locality: null,
        district: null,
        pincode: null,
        applyagain: false,
        lat: 10.535387441362912,
        lon: 76.21544288981148,
      },
      newProfilepic: false,
      proPicImg: null,
      proPic: null,
      proPicSts: false,
      newCoverpic: false,
      coverPicImg: null,
      coverPic: null,
      coverPicSts: false,
      newIdproof: false,
      documentImg: null,
      document: null,
      documentSts: false,
      showSnackBar: false,
      msg: null,
      ServerError: false,
      timeout: 5000,
      appLoading: false,
      filename: "",
      userData: [],
      uploadCoverPhoto: new FormData(),
      uploadPhoto: new FormData(),
      uploadIdProof: new FormData(),
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        minPhone: (value) => value.length == 10 || "Invalid Phone",
        //  pincode: (value) => value.length == 6 || "Please provide valid pincode",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
       
      },
       phoneRules: [
          (v) => !!v || "phone is required",
          (v) =>
            (v && v.length <= 10) || "number must be less than 11 characters",
          (v) =>
            (v && v.length >= 10) ||
            "number must be greater than 10 characters",
          (v) => /^\d{10}$/.test(v) || "phone number must be a number",
        ],
        pinRules: [
          (v) => !!v || "Pincode is Required",
          (v) => /^(\d{4}|\d{6})$/.test(v) || "Pincode must be valid",
        ],
        gstRules: [
          (v) => !!v || "GSTID is Required",
          (v) =>
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
              v
            ) || "GSTID must be valid",
        ],
        ifscRules: [
          (v) => !!v || "IFSC Code is Required",
          (v) =>
            /[A-Z|a-z]{4}[0][a-zA-Z0-9]{6}$/.test(
              v || "IFSC Code must be valid"
            ),
        ],
        accRules: [
          (v) => !!v || "Account Number is Required",
          (v) =>
            /^([0-9]{11})|([0-9]{2}-[0-9]{3}-[0-9]{6})$/.test(v) ||
            "Account Number must be valid",
        ],
      cropImageDialog: false,
      currentImage: null,
      cropCoverImageDialog: false,
      currentImage2: null,
    };
  },

  beforeMount() {
    this.getData();
    // this.geolocate();
    const marker = {
      lat: this.seller.lat,
      lng: this.seller.lon,
    };
    this.markers.push({ position: marker });
  },
  methods: {
    clickPlace(location) {
      this.markers.splice(0, 1);
      this.currentLocation = location;
      const marker = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      this.markers.push({ position: marker });
      this.seller.lat = marker.lat;
      this.seller.lon = marker.lng;
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        // this.center = {
        //   lat: position.coords.latitude,
        //   lng: position.coords.longitude,
        // };
        this.lat = position.coords.latitude;
        this.lon = position.coords.longitude;
        const marker = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.markers.push({ position: marker });
      });
    },

    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.seller.email = response.data.data.email;
            this.seller.phone = response.data.data.phone;
            if (response.data.data.status == "Rejected") {
              this.seller = response.data.data;
              this.markers.splice(0, 1);
              this.seller.lon = this.seller.seller.gps[0];
              this.seller.lat = this.seller.seller.gps[1];
              const marker = {
                lat: this.seller.lat,
                lng: this.seller.lon,
              };
              this.markers.push({ position: marker });

              this.seller.ownername = this.seller.seller.ownername;
              this.seller.accountnumber = this.seller.seller.accountnumber;
              this.seller.accountholder = this.seller.seller.accountholder;
              this.seller.bankname = this.seller.seller.bankname;
              this.seller.ifsccode = this.seller.seller.ifsccode;
              this.seller.branch = this.seller.seller.branch;
              this.seller.gstid = this.seller.seller.gstid;

              this.profilepic = this.seller.image;
              this.coverpicture = this.seller.seller.coverimage;
              this.idproofpic = this.seller.seller.idproof[0];
            }
            if (this.seller.status == "Rejected") {
              this.seller.applyagain = true;
            }
            this.$store.commit("userData", response.data.data);
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    // uploadProPicImg(e) {
    //   var files = e.target.files || e.dataTransfer.files;
    //   if (!files.length) return;
    //   if (files[0].size > 5097152) {
    //     // this.msg = "File Should be less than 2MB";
    //     // this.showSnackBar = true;
    //     return;
    //   }
    //   this.proPic = e.target.files[0];
    //   var reader = new FileReader();
    //   reader.onload = (e) => {
    //     this.proPicImg = e.target.result;
    //   };
    //   this.proPicSts = true;
    //   this.newProfilepic = true;
    //   reader.readAsDataURL(files[0]);
    // },

    imageCropper(payload) {
      this.cropImageDialog = payload.dialog;
      this.cropCoverImageDialog = payload.dialog;
      if (payload.image) {
        this.collectImages(payload.image, payload.imageType);
      }
    },
    uploadProPicImg(e) {
      this.currentImage = URL.createObjectURL(e.target.files[0]);
      this.cropImageDialog = true;
    },
    collectImages(image, imageType) {
      if (imageType == "profilePic") {
        this.proPic = image;
        var img = new Image();
        img.src = window.URL.createObjectURL(image);
        img.onload = () => {
          this.proPicImg = URL.createObjectURL(image);
        };
        this.proPicSts = true;
        this.newProfilepic = true;
      } else if (imageType == "coverPic") {
        this.coverPic = image;
        var img2 = new Image();
        img2.src = window.URL.createObjectURL(image);
        img2.onload = () => {
          this.coverPicImg = URL.createObjectURL(image);
        };
        this.coverPicSts = true;
        this.newCoverpic = true;
      }
    },
    uploadCoverPicImg(e) {
      this.currentImage2 = URL.createObjectURL(e.target.files[0]);
      this.cropCoverImageDialog = true;
    },
    // uploadCoverPicImg(e) {
    //   var files = e.target.files || e.dataTransfer.files;
    //   if (!files.length) return;
    //   if (files[0].size > 5097152) {
    //     this.msg = "File Should be less than 1MB";
    //     this.showSnackBar = true;
    //     return;
    //   }
    //   this.coverPic = e.target.files[0];
    //   var reader = new FileReader();
    //   reader.onload = (e) => {
    //     this.coverPicImg = e.target.result;
    //   };
    //   this.coverPicSts = true;
    //   this.newCoverpic = true;
    //   reader.readAsDataURL(files[0]);
    // },

    uploadDocuments(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5097152) {
        // this.msg = "File Should be less than 2MB";
        // this.showSnackBar = true;
        return;
      }
      this.filename = e.target.files[0].name;
      this.document = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.documentImg = e.target.result;
      };
      this.documentSts = true;
      this.newIdproof = true;
      reader.readAsDataURL(files[0]);
    },

    delProPic() {
      this.proPicImg = "";
      this.proPic = "";
      (this.currentImage = null), (this.newProfilepic = false);
      // this.profilepic = "";
    },

    delCoverPic() {
      this.coverPicImg = "";
      (this.currentImage2 = null), (this.coverPic = "");
      this.newCoverpic = false;
    },
    delDocument() {
      this.documentImg = "";
      this.document = "";
      this.filename = "";
      this.newIdproof = false;
    },

    validateInput() {
      if (!this.seller.organization) {
        this.seller.organization = "";
        this.msg = "Please provide name of company";
        this.showSnackBar = true;
        return;
      }
      if (!this.seller.ownername) {
        this.msg = "Please provide name of owner";
        this.showSnackBar = true;
        return;
      }
      // if (!this.seller.streetAddress) {
      //   this.msg = "Please provide address of owner ";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.locality) {
      //   this.msg = "Please provide Locality";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.city) {
      //   this.msg = "Please provide city";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.district) {
      //   this.msg = "Please provide district";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.state) {
      //   this.msg = "Please provide state";
      //   this.showSnackBar = true;
      //   return;
      // }
      if (!this.seller.pincode) {
        this.msg = "Please provide pincode";
        this.showSnackBar = true;
        return;
      }
      // if (!this.lon && !this.lat) {
      //   this.msg = "Please choose your location";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.filename && this.idproofpic == null) {
      //   this.msg = "Please upload proof id";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.proPicImg && this.profilepic == null) {
      //   this.msg = "Please upload Profile picture";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.coverPicImg && this.coverpicture == null) {
      //   this.msg = "Please upload Cover picture";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.bankname) {
      //   this.msg = "Please provide name of the bank";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.accountholder) {
      //   this.msg = "Please provide name of account holder";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.accountnumber) {
      //   this.msg = "Please provide the account number";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.ifsccode) {
      //   this.msg = "Please provide IFSC code";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.branch) {
      //   this.msg = "Please provide name of the branch";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.gstid) {
      //   this.msg = "Please provide the GST id";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.email) {
      //   this.msg = "Please provide Email id";
      //   this.showSnackBar = true;
      //   return;
      // }
      // if (!this.seller.phone) {
      //   this.msg = "Please provide the phone number";
      //   this.showSnackBar = true;
      //   return;
      // }

      this.register();
    },
    // getDetails(){
    //     this.appLoading = true;
    //   axios({
    //     method: "GET",
    //     url: "/user/profile",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       if (response.data.status) {
    //         this.userData = response.data.data;

    //       }
    //     })
    //     .catch((err) => {
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },

    register() {
      this.appLoading = true;

      // this.seller.whatsapp = this.seller.phone;
      this.seller.id = this.$store.state.userData._id;

      axios({
        method: "POST",
        url: "/user/Edit",
        data: this.seller,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (this.newProfilepic == true) {
              this.uploadPic();
            }
            if (this.newCoverpic == true) {
              this.uploadCovPic(this.$store.state.userData._id);
            }
            if (this.newIdproof == true) {
              this.uploadDoc();
            }
            if (response.data.data.status == "Active") {
              this.$router.push("/Seller");
            } else if (response.data.data.status == "Pending") {
              this.$router.push({
                name: "sellerStatus",
              });
              this.msg =
                "Your Account is under processing for Admin Approval... Please wait for a while and Relogin ";
              this.showSnackBar = true;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadPic() {
      this.uploadPhoto.append("photos", this.proPic);
      this.appLoading = true;
      axios({
        method: "post",
        url: "/user/uploadImage",
        data: this.uploadPhoto,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.msg = response.data.msg;

          if (response.data.status) {
            this.appLoading = false;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })

        .catch((e) => {
          console.log(e);
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    uploadDoc() {
      this.uploadIdProof.append("images", this.document);
      this.appLoading = true;
      axios({
        method: "post",
        url: "/user/uploadproofs",
        data: this.uploadIdProof,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })

        .catch((e) => {
          console.log(e);
          this.appLoading = false;
          this.ServerError = true;
        });
    },

    uploadCovPic(id) {
      this.appLoading = true;
      this.uploadCoverPhoto.append("id", id);
      this.uploadCoverPhoto.append("image", this.coverPic);
      axios({
        method: "POST",
        url: "/User/seller/UploadCoverImage",
        data: this.uploadCoverPhoto,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.$router.push({
              name: "sellerStatus",
            });
          }
          this.msg = response.data.msg;
          // this.showSnackBar = true;
        })

        .catch((e) => {
          console.log(e);
          this.appLoading = false;
          this.ServerError = true;
        });
    },
  },
};
</script>

<style >
.upload {
  background: transparent url("/assets/images/fileupload.png") 0% 0% no-repeat
    padding-box;
}
.dottedline {
  border: none;
  border-top: 1px dashed rgb(82, 79, 79);
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
}
</style>